<template>
  <div v-html="champ.content"></div>
</template>

<script>
export default {
  props: ["champ", "is_disable"],
};
</script>

<style lang="scss" scoped>
</style>